import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { InputText } from "../../../components/Inputs";
import {
  SearchIconButton,
  CancelIconButton,
} from "../../../components/Buttons";

import { connect } from "react-redux";
import { search } from "../actions";
import { set } from "lodash";

const mapStateToProps = null;
const mapDispatchToProps = (dispatch) => ({
  search: (...args) => dispatch(search(...args)),
});

function SearchForm({ className, match, search }) {
  const [text, setText] = useState(match.params.id || "");
  const [error, setError] = useState(null);
  const fieldRef = useRef(null);

  useEffect(() => {
    fieldRef.current && fieldRef.current.focus();
  }, []);

  const onChangeText = (event) => {
    setText(event.target.value);
    // clear error if text is valid
    if (event.target.value.length >= 3) {
      setError(null);
    }
  };

  const onReset = () => {
    setText("");
    setError(null);
    fieldRef.current && fieldRef.current.focus();
  };

  const onSearch = () => {
    if (text.length < 3) {
      setError("Bitte mindestens 3 Zeichen eingeben");
      return;
    }
    setError(null);
    search({ text });
  };

  return (
    <div
      className={`search-form w3-light-grey w3-border-bottom pad-big ${className}`}
    >
      <div className="container">
        <div
          className="w3-cell-row"
          style={{ width: "600px", margin: "0 auto" }}
        >
          <div className="w3-cell w3-cell-top">
            <div className="clearfix search-input-holder">
              <InputText
                id="search-input"
                className="search-input no-corner-rht"
                style={{ height: "43px" }}
                value={text}
                ref={fieldRef}
                onChange={onChangeText}
                onKeyUp={(event) => event.keyCode === 13 && onSearch()}
                placeholder="Suchtext eingeben (mindestens 3 Zeichen)"
              />
              <CancelIconButton
                id="search-reset-btn"
                className="reset-btn pad no-border"
                style={{ padding: "7px" }}
                onClick={onReset}
              />
            </div>
            {error && (
              <div id="search-error" className="w3-text-red pad-top">
                {error}
              </div>
            )}
          </div>
          <div className="w3-cell w3-cell-top" style={{ width: "56px" }}>
            <SearchIconButton
              id="search-btn"
              className="pad w3-border w3-round no-border-lft no-corner-lft"
              onClick={onSearch}
              style={{ height: "43px" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

SearchForm.propTypes = {
  className: PropTypes.string,
  match: PropTypes.object,
  search: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(SearchForm));
